import type { ReactNode } from "react";

type RichTextHtmlProps = {
  className?: string;
  html?: ReactNode;
};

export const RichTextHtml = ({ className, html }: RichTextHtmlProps) => {
  if (!html) {
    return null;
  }

  if (typeof html === "string") {
    return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return <div className={className}>{html}</div>;
};
